// extracted by mini-css-extract-plugin
export default {"container":"RecommendationReview-module--container--e49c0","logo":"RecommendationReview-module--logo--62120","link":"RecommendationReview-module--link--87534"};